var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326 112",
    style: {
      enableBackground: "new 0 0 326 112"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C9CAC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.4,63.3c15.9-12.9,32.3-24.2,54.3-25.4c-1.2,4.1-2.1,7.5-3.1,11c0.3,0.1,0.5,0.2,0.8,0.4 c2.7-5.1,5.5-10.1,8.3-15.3C213.2,30.1,175.5,48.7,169.4,63.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123,29.1c2.1-1.5,25.9-14.2,37-19.8c1.2-0.6,3.2-0.9,4.4-0.3c11.7,5.9,35.7,18.8,36.6,19.6 c-1.8-0.1-19,8.5-17.5,14.7c0.2,1.2-1.9,3.7-3.3,4.1c-11.7,3.1-23.4,3.1-35.1,0.1c-1.4-0.4-3.6-2.5-3.5-3.6 C142.5,36.5,131.3,30.9,123,29.1 M144,40.1h36.9c0-1.1,0.1-7.9-0.7-8.8c-1.1-4-35.4-3.1-35.8-0.3C144.2,31.3,144,40.1,144,40.1  M180.9,44.8c-9.3-3.9-30.4-3.7-36.4,0.2C156.7,47.5,168.3,47.7,180.9,44.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.6,63.5c-15.9-12.9-32.3-24.2-54.3-25.4c1.2,4.1,2.1,7.5,3.1,11c-0.3,0.1-0.5,0.2-0.8,0.4 c-2.7-5.1-5.5-10.1-8.3-15.3C112.8,30.4,150.5,49,156.6,63.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M148.1,62c-12-5.3-24.2-9.4-37.1-11.5c-3.1-0.5-3.4-2.5-3.3-5.4C122.4,48.2,135.8,53.9,148.1,62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.2,62.5c12.6-8.4,26.4-14.2,41.4-17.5c0.1,3-0.4,5-3.8,5.6C200.7,52.7,188.3,56.9,176.2,62.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.5,60.6c2.2-0.1,4.4-0.2,6.6-0.2c1.9,0,2.5,0.8,1.6,2.5c-2.1,4-4.2,7.9-6.4,11.8 c-0.8,1.5-1.9,1.5-2.7,0.1c-2.4-3.8-4.8-7.7-7.1-11.6c-0.9-1.5-0.4-2.4,1.5-2.5C158.1,60.7,160.3,60.7,162.5,60.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110,84.6h5.4l4.4,7.1l4.4-7.1h5.4v18.3h-5.1V92.4l-4.7,7.2h-0.1l-4.7-7.1v10.5h-5V84.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.9,95.9L131.9,95.9c0-4.1,3.3-7.5,7.9-7.5c4.5,0,7.8,3.3,7.8,7.4v0.1c0,4-3.3,7.4-7.9,7.4 C135.1,103.3,131.9,99.9,131.9,95.9z M142.7,95.9L142.7,95.9c0-1.8-1.3-3.3-3-3.3c-1.8,0-3,1.4-3,3.1v0.1c0,1.7,1.3,3.2,3,3.2 C141.5,99,142.7,97.6,142.7,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.6,88.7h5v1.9c0.9-1.2,2.2-2.3,4.2-2.3c1.9,0,3.3,0.8,4.1,2.3c1.2-1.4,2.7-2.3,4.7-2.3 c3,0,4.8,1.9,4.8,5.2v9.3h-5v-7.7c0-1.5-0.8-2.4-1.9-2.4s-2,0.8-2,2.4v7.7h-5v-7.7c0-1.5-0.8-2.4-1.9-2.4s-2,0.8-2,2.4v7.7h-5 V88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.9,98.5v-5.8h-1.7v-4h1.7v-3.6h5v3.6h3.3v4h-3.3v4.8c0,1,0.4,1.4,1.4,1.4c0.7,0,1.3-0.2,1.9-0.5v3.9 c-0.9,0.5-2.1,0.8-3.5,0.8C177.7,103.2,175.9,101.9,175.9,98.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185.7,98.9L185.7,98.9c0-3,2.2-4.5,5.6-4.5c1.3,0,2.6,0.3,3.4,0.6v-0.2c0-1.5-0.9-2.3-2.8-2.3 c-1.5,0-2.6,0.3-3.9,0.8l-1-3.5c1.6-0.7,3.3-1.1,5.7-1.1c2.5,0,4.3,0.6,5.4,1.7c1.1,1,1.5,2.5,1.5,4.5v8.2h-4.9v-1.5 c-1,1.1-2.3,1.8-4.2,1.8C187.7,103.2,185.7,101.7,185.7,98.9z M194.7,97.8v-0.7c-0.5-0.2-1.2-0.4-1.9-0.4c-1.4,0-2.3,0.7-2.3,1.8 v0.1c0,1,0.7,1.5,1.8,1.5C193.7,100.1,194.7,99.2,194.7,97.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.6,99.6l6.6-6.9h-6.3v-4h12.9V92l-6.6,6.9h6.6v4h-13.2V99.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35282da0fd0c17da8f5f7f1e5e68ba9c.svg";
export { ForwardRef as ReactComponent };